var authorization = require('../services/authorization');
var router = require('../services/router');
var keyboardActions = require('../services/keyboardActions');

var preloader = require('../components/preloader');
var messages = require('../components/messages');

var Quote = function (data) {
    var self = this;

    this.canceled = ko.observable(false);

    this.bulk_order_id = data.bulk_order_id;
    this.po_number = ko.observable(data.po_number || '');
    this.submit_date = ko.observable(data.submit_date || '');
    this.is_pending = ko.observable(Boolean(data.is_pending));
    this.was_signed = ko.observable(Boolean(data.was_signed));

    this.file_uploaded = ko.observable(false);
    
    this.focused = ko.observable();

    this.file_uploaded.subscribe(function (value) {
        if (!value) return;

        setTimeout(function () {
            self.focused('file-uploaded');
        });
    });

    this.focused = ko.observable();

    this.file_uploaded.subscribe(function (value) {
        if (!value) return;

        setTimeout(function () {
            self.focused('file-uploaded');
        });
    });

    this.search = function (query) {
        var regex = new RegExp(query, 'i');

        if (self.po_number().search(regex) != -1) return true;
        if (self.submit_date().search(regex) != -1) return true;
        if (this.is_pending() && 'pending'.search(regex) != -1) return true;
        if (!this.is_pending() && 'download'.search(regex) != -1) return true;

        return false;
    };

    this.modifyQuote = function () {
        router.goTo(
            'update-existing-order',
            {
                bulk_order_id: self.bulk_order_id
            }
        );
    };
    this.cancelQuote = function () {
        function cancelCallback() {
            self.canceled(true);
        }
        var message = 'You are about to cancel your Bulk Order. This action cannot be undone and you will have to resubmit your request. Are you sure you want to cancel?';
        if(!confirm(message)){
            return false;
        }
        self.api.cancel(cancelCallback);
    };

    this.uploadFile = function (me, e) {
        if (!keyboardActions.isEnter(e.keyCode)) return true;

        e.target.click();
    };

    this.init = function () {
        setTimeout(function () {
            $('#fileupload-' + data.bulk_order_id).fileupload({
                url: 'rest.php/upload_signed_quote/' + data.bulk_order_id,
            }).bind('fileuploadsend', function (e, data) {
                preloader.show('file-upload');
            }).bind('fileuploaddone', function (e, data) {
                self.file_uploaded(true);
            }).bind('fileuploadfail', function (e, data) {
                var error = data.jqXHR.responseJSON.error;

                if (error.code === 401) {
                    router.goTo('login');
                    authorization.setIsAuthorized(false);
                }

                messages.addItem(error.message || 'Something went wrong, your quote wasn\'t uploaded. Try again please.');
            }).bind('fileuploadalways', function (e, data) {
                preloader.hide('file-upload');
            });
        })
    };

    this.api = {
        cancel: function (callback) {
            preloader.show('cancel-quote');
            $.ajax({
                url: 'rest.php/quote/' + self.bulk_order_id,
                method: 'DELETE',
                dataType: 'json'
            }).done(function (resp) {
                if (callback) callback(true, resp.data);
            }).fail(function (jqXHR, textStatus, error) {
                var error = jqXHR.responseJSON.error;

                if (error.code === 401) {
                    router.goTo('login');
                    authorization.setIsAuthorized(false);
                }

                messages.addItem(error.message);

                if (callback) callback(false);
            }).always(function () {
                preloader.hide('cancel-quote');
            });
        }
    };

    this.init();
};

module.exports = Quote;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/ExistingOrders/Quote.js
// module id = 23
// module chunks = 0